import { render, staticRenderFns } from "./UsuarioDialog.vue?vue&type=template&id=fe980baa&scoped=true"
import script from "./UsuarioDialog.vue?vue&type=script&lang=js"
export * from "./UsuarioDialog.vue?vue&type=script&lang=js"
import style0 from "./UsuarioDialog.vue?vue&type=style&index=0&id=fe980baa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe980baa",
  null
  
)

export default component.exports